import React, { ReactNode } from 'react';
import { Button } from 'antd';

interface CreateButtonProps {
  onClick: () => void;
  label: string;
  icon?: ReactNode;
  color?: string;
  disable?: boolean;
}
const PrimaryButton: React.FC<CreateButtonProps> = ({
  onClick,
  label,
  icon,
  color = '#A23231',
  disable = false,
}) => {
  return (
    <>
      <Button
        disabled={disable}
        style={{
          backgroundColor: disable ? 'bg-gray-300' : color,
          borderRadius: '0.75rem',
          color: disable ? 'text-gray-500' : 'white',
          fontWeight: 'bold',
        }}
        type="primary"
        icon={icon}
        onClick={onClick}
      >
        {label}
      </Button>
    </>
  );
};

export default PrimaryButton;
